import React, { PureComponent } from 'react';

// import field data
import { mortgagePayment } from './data';

// import components
import {
  CalcTitle,
  CalcFieldRow,
  CalcField,
  CalcError,
  CalcInput,
  CalcLabel,
  CalcWrapper,
  CalcButton,
  CalcResultsWrapper,
  CalcResultsContainer,
} from './styled';

class MortgagePayment extends PureComponent {
  state = {
    values: { loanAmount: '', interestRate: '', loanTerm: '' },
    errors: { loanAmount: '', interestRate: '', loanTerm: '' },
    payment: 0,
    calculated: false,
  };

  drawFields = fields => {
    return fields.map(field => {
      const { config, label, name, validators } = field;
      return (
        <CalcField key={name}>
          <CalcInput
            {...config}
            type="text"
            aria-labelledby={name}
            name={name}
            id={name}
            value={this.state.values[name]}
            onChange={e => this.handleChange(e, validators)}
            required
          />
          <CalcLabel htmlFor={name}>{label}</CalcLabel>
          {this.state.errors[name] ? (
            <CalcError className="error">{this.state.errors[name]}</CalcError>
          ) : (
            <CalcError>&nbsp;</CalcError>
          )}
        </CalcField>
      );
    });
  };

  handleChange = (e, validators) => {
    const { name, value } = e.target;

    const updateObj = { ...this.state.values };

    updateObj[name] = value;

    // validators.forEach(validator => {
    //   this[validator](value, name);
    // });

    this.setState({ values: updateObj });
  };

  calculatePayment = () => {
    const {
      values: { loanAmount, interestRate, loanTerm },
    } = this.state;

    const principal = loanAmount.replace('$', '').replace(/,/g, '');
    const rate = interestRate.replace('%', '').replace(/ /g, '') / 100 / 12;
    const term = loanTerm.replace(' years', '') * 12;

    const numerator = rate * Math.pow(1 + rate, term);
    const denominator = Math.pow(1 + rate, term) - 1;
    const payment = (principal * (numerator / denominator))
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    this.setState({
      calculated: true,
      payment,
    });

    return payment;
  };

  render() {
    const {
      calculated,
      values: { loanAmount, interestRate, loanTerm },
    } = this.state;
    return (
      <>
        <CalcTitle>Estimate Your Monthly Payment</CalcTitle>
        <CalcFieldRow>{this.drawFields(mortgagePayment)}</CalcFieldRow>
        <CalcWrapper>
          <CalcButton onClick={() => this.calculatePayment()}>Calculate</CalcButton>
        </CalcWrapper>
        {calculated ? (
          <CalcResultsWrapper>
            <h3>Loan Summary</h3>
            <CalcResultsContainer>
              <div>
                <h4>Monthly Principal & Interest Payment</h4>
                <p>(Insurance and taxes not included)</p>
                <h5>${this.state.payment}</h5>
              </div>
              <div>
                <h4>Loan Amount</h4>
                <p>&nbsp;</p>
                <h5>{loanAmount}</h5>
              </div>
              <div>
                <h4>Interest Rate</h4>
                <p>&nbsp;</p>
                <h5>{interestRate}</h5>
              </div>
              <div>
                <h4>Term of Loan</h4>
                <p>&nbsp;</p>
                <h5>{loanTerm}</h5>
              </div>
            </CalcResultsContainer>
          </CalcResultsWrapper>
        ) : null}
      </>
    );
  }
}

export default MortgagePayment;
